<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

import SmartCampaignCard from './SmartCampaignCard.vue';

const props = defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['edit', 'delete', 'toggleStatus']);

const allInboxes = useMapGetter('inboxes/getInboxes');

const resolveInboxes = inboxIds => {
  if (!inboxIds?.length) return [];
  return inboxIds
    .map(id => (allInboxes.value ?? []).find(inbox => inbox.id === id))
    .filter(Boolean)
    .map(inbox => ({ id: inbox.id, name: inbox.name }));
};

const mappedCampaigns = computed(() =>
  props.campaigns
    .map(c => ({
      ...c,
      resolvedInboxes: resolveInboxes(c.campaign_config?.inbox_ids),
    }))
    .sort((a, b) => {
      if (a.status === 'active' && b.status !== 'active') return -1;
      if (a.status !== 'active' && b.status === 'active') return 1;
      return 0;
    })
);
</script>

<template>
  <div class="flex flex-col gap-4">
    <SmartCampaignCard
      v-for="campaign in mappedCampaigns"
      :key="campaign.id"
      :name="campaign.name"
      :description="campaign.description"
      :public-content="campaign.public_content"
      :private-content="campaign.private_content"
      :reference-content="campaign.reference_content"
      :hashtags="campaign.campaign_config?.hashtags ?? []"
      :inboxes="campaign.resolvedInboxes"
      :starts-at="campaign.starts_at"
      :ends-at="campaign.ends_at"
      :timezone="campaign.campaign_config?.timezone"
      :status="campaign.status ?? 'inactive'"
      @edit="emit('edit', campaign)"
      @delete="emit('delete', campaign)"
      @toggle-status="emit('toggleStatus', campaign)"
    />
  </div>
</template>
